import { render, staticRenderFns } from "./PackageIncludes.vue?vue&type=template&id=640acd60&scoped=true&"
import script from "./PackageIncludes.vue?vue&type=script&lang=js&"
export * from "./PackageIncludes.vue?vue&type=script&lang=js&"
import style0 from "./PackageIncludes.vue?vue&type=style&index=0&id=640acd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640acd60",
  null
  
)

export default component.exports